module.exports = __webpack_public_path__ + "static/media/photo2.9c1082fe.jpg";